import React, { useState } from 'react';
import { useRoomContext } from '@livekit/components-react';
import { LocalTrackPublication, Track } from 'livekit-client';

const ScreenShareButton = () => {
  const room = useRoomContext();
  const [isSharing, setIsSharing] = useState(false);

  const toggleScreenShare = async () => {
    if (!isSharing) {
      try {
        // Use the built-in LiveKit screen sharing API
        await room.localParticipant.setScreenShareEnabled(true);
        // const stream = await navigator.mediaDevices.getDisplayMedia({ video: true });
        // console.log(stream); 
        setIsSharing(true);
      } catch (err) {
        console.error('Error sharing screen:', err);
      }
    } else {
      try {
        // Disable screen sharing
        await room.localParticipant.setScreenShareEnabled(false);
        setIsSharing(false);
      } catch (err) {
        console.error('Error stopping screen share:', err);
      }
    }
  };

  return (
    <button 
      className={`control-button ${isSharing ? 'active' : ''}`}
      onClick={toggleScreenShare}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
      </svg>
    </button>
  );
};

export default ScreenShareButton;